__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@clusterio/master";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult.catch(handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@clusterio/lib", "2.0.0-alpha.12", () => (Promise.all([__webpack_require__.e(111), __webpack_require__.e(789)]).then(() => (() => (__webpack_require__(86473))))));
			register("@clusterio/web_ui", "2.0.0-alpha.12", () => (Promise.all([__webpack_require__.e(757), __webpack_require__.e(559), __webpack_require__.e(931), __webpack_require__.e(235)]).then(() => (() => (__webpack_require__(57235))))));
			register("antd", "4.16.0", () => (Promise.all([__webpack_require__.e(69), __webpack_require__.e(757), __webpack_require__.e(302), __webpack_require__.e(509), __webpack_require__.e(931), __webpack_require__.e(554)]).then(() => (() => (__webpack_require__(63654))))));
			register("react-dom", "16.14.0", () => (Promise.all([__webpack_require__.e(173), __webpack_require__.e(302), __webpack_require__.e(305)]).then(() => (() => (__webpack_require__(29173))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(375), __webpack_require__.e(452), __webpack_require__.e(188), __webpack_require__.e(569)]).then(() => (() => (__webpack_require__(57413))))));
			register("react-router", "5.2.0", () => (Promise.all([__webpack_require__.e(375), __webpack_require__.e(582), __webpack_require__.e(452), __webpack_require__.e(135), __webpack_require__.e(394)]).then(() => (() => (__webpack_require__(58582))))));
			register("react", "16.14.0", () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(68178))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};